import React, { useState } from "react";
import Box from "@mui/material/Box";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import { Brightness1 } from "@mui/icons-material";
import TableContainer from "@mui/material/TableContainer";
import TableRow from "@mui/material/TableRow";

import EnhancedTableHead from './table_head';
import CheckBoxCustom from "../checkbox";
import { formatCurrency } from "../../helpers/utils";

const descendingComparator = (a, b, orderBy) => {
  if (b[orderBy] < a[orderBy]) return -1;
  if (b[orderBy] > a[orderBy]) return 1;
  return 0;
};

const getComparator = (order, orderBy) => {
  return order === "desc"
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
};

const stableSort = (array, comparator) => {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
};

const page = 0;
const rowsPerPage = 50;

const EnhancedTable = ({
  table_data = [], 
  tableSettings = {}, 
  tableHeadings = {},
  tabelCellStyles = {},
  selectable = false, 
  selectedCards = [],
  handleSelectAllClick,
  handleRowClick
 }) => {

  const [order, setOrder] = useState("asc");
  const [orderBy, setOrderBy] = useState("createdAt");

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const isSelected = (cardNumber) => selectedCards.indexOf(cardNumber) !== -1;

  const getSelectedHeaders = () => {
    return Object.entries(tableSettings).map(([key, value]) => ({
      id: key,
      selected: value
    })).filter(h => h.selected);
  }

  const getStatusCell = (id, status) => {
    if(status === "active") return [
      <Brightness1 key={`${id}-${status}`} style={{ color: "#14BD62", fontSize: 8, marginBottom: 4, marginRight: 6 }}/>,
      "Идэвхитэй"
    ]; else if (status === 'inactive') return [
      <Brightness1 key={`${id}-${status}`} style={{ color: "#DF2647", fontSize: 8, marginBottom: 4, marginRight: 6 }}/>,
      "Идэвхигүй"
    ]; else return []
  }

  const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - table_data.length) : 0;

  return (
    <Box>
      <TableContainer>
        <Table sx={{ minWidth: "100%" }} size={"medium"}>
          <EnhancedTableHead
            order={order}
            orderBy={orderBy}
            tableHeadings={tableHeadings}
            tabelCellStyles={tabelCellStyles}
            numSelected={selectedCards.length}
            onRequestSort={handleRequestSort}
            rowCount={table_data.length}
            onSelectAllClick={handleSelectAllClick}
            selectedHeaders={getSelectedHeaders()}
            selectable={selectable}
          />
          <TableBody>
            {
              stableSort(table_data, getComparator(order, orderBy))
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((row, index) => {
                  const isItemSelected = isSelected(row.cardNumber);
                  return (
                    <TableRow
                      hover
                      onClick={(event) => handleRowClick(event, row.cardNumber)}
                      aria-checked={isItemSelected}
                      tabIndex={-1}
                      key={row.cardNumber}
                      selected={isItemSelected}
                    >
                      { selectable && <TableCell padding="checkbox">
                        <CheckBoxCustom 
                          value={isItemSelected} 
                        />
                      </TableCell>}
                      {
                        getSelectedHeaders().map(h => (
                          <TableCell
                            key={`${row.cardNumber}-${h.id}`}
                            style={tabelCellStyles[h.id]}
                          >
                            {
                              h.id === 'balance' ? formatCurrency(row[h.id]) :
                                h.id === 'status' ? getStatusCell(row.cardNumber, row[h.id]) : row[h.id]
                            }
                          </TableCell>
                        ))
                      }
                    </TableRow>
                  )
                })
            }
            {
              emptyRows > 0 && (
                <TableRow style={{ height: 53 * emptyRows }}>
                  <TableCell colSpan={getSelectedHeaders().length} />
                </TableRow>
              )
            }
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
}

export default EnhancedTable;